<style lang="scss">
#adminindex {
  svg {
    fill: $c-dark-blue;
    cursor: default;
  }

  svg.active {
    fill: $c-dark-blue;
  }

  svg.disabled {
    fill: $c-medium-grey !important;
  }

  svg.hover:hover {
    cursor: pointer;
    fill: $c-medium-blue;
  }

  svg.delete {
    fill: #ff6962;
  }
}
</style>

<template>
  <div id="adminindex">
    <Headline h1="Administration" />
    <div class="row mb-3 mt-1">
      <div class="col-12">
        <AdminMenu />
      </div>
    </div>
    <router-view />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import AdminMenu from '../../../components/admin/AdminMenu.vue';

export default defineComponent({
  components: {
    AdminMenu,
  },
  setup() {
    return {};
  },
});
</script>
